import React, { useState } from 'react'
import styled from 'styled-components'
import { TodoListDataTable } from '../../Components/Leads/TodoList/TodoListDataTable'
import { TodoListFirst } from '../../Components/Leads/TodoList/TodoListFirst'
import { colors } from '../../Shared/colors'

export const TodoList = () => {
  const [filters, setFilters] = useState({})

  const handleFilterChange = (newFilters) => {
    setFilters(newFilters)
  }

  return (
    <Main>
        <TodoListFirst onFilterChange={handleFilterChange}/>
        <TodoListDataTable filters={filters}/>
    </Main>
  )
}

const Main = styled.div`
  background: linear-gradient(135deg, ${colors.lightWhite} 0%, ${colors.inputWhite} 100%);
  min-height: calc(100vh - 10vh);
  padding: 1rem 0;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
  gap: 1rem;
`

